
class PostTabs {
    constructor(el) {
        this.el = el;
        this.buttons = this.el.querySelectorAll(".tab-btn");
        this.contents = this.el.querySelectorAll(".tab-content");
        this.attachEvents();
    }

    attachEvents() {
        this.buttons.forEach(btn => {
            btn.addEventListener("click", () => this.onClick(btn));
        });
    }

    onClick(btn) {
        const target = btn.dataset.tab;
        // remove active classes
        this.buttons.forEach(b => b.classList.remove("active"));
        this.contents.forEach(c => c.classList.remove("active"));
        // add active
        btn.classList.add("active");
        const activated = this.el.querySelector(`#${target}`);
        activated.classList.add("active");
    }
    
}

export default PostTabs;
